import './ShinyText.css';

import Typography from './Typography';

const ShinyText = ({ text, disabled = false, speed = 5, className = '' }) => {
  const animationDuration = `${speed}s`;

  return (
    <div
      className={`shiny-text ${disabled ? 'disabled' : ''} ${className}`}
      style={{ animationDuration }}
    >
      <Typography variant="button" type="utility">{text}</Typography>
    </div>
  );
};

export default ShinyText;
